import React, { Fragment, useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';
import WizardInput from '../../../components/auth/wizard/WizardInput';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import RequiredMarked from '../../../components/common/RequiredMarked';
import { SolicitudContext } from '../SolicitudContext';
import { urlApi } from '../../../configuracion/serverConfig';
import cogoToast from 'cogo-toast';
import Select from 'react-select';

const PesonalReference = () => {
  const { handleFormRef, client } = useContext(SolicitudContext);
  const { register, triggerValidation, errors, setValue, getValues } = useForm();

  const [contactos, setContactos] = useState([]);
  const [contacto, setContacto] = useState({});

  useEffect(() => {
    if (!client) {
      return;
    }
    fetch(urlApi + '/solicitud/contactos/' + client.id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json'
      }
    })
      .then(res => res.json())
      .then((data) => {
        data.unshift({ identificacion: "", nombre: "" });
        setContactos(data);
      })
      .catch(err => cogoToast.error(String(err), { position: 'bottom-right', heading: 'Error en la respuesta' }));
  }, [client])

  const onChange = async e => {
    const { name, value } = e.target;
    setValue(name, value);
    contacto[name] = value;
    setContacto(contacto);
    const formRefData = getValues();
    await triggerValidation();
    const isValid = Object.keys(errors).length < 1;
    handleFormRef(isValid ? formRefData : null);
  }

  const onAnterior = async (item) => {
    setValue("identificacion", item.identificacion);
    setValue("fullName", item.nombre);
    setValue("address", item.domicilio);
    setValue("phone", item.telefono);
    setValue("email", item.correo);
    setContacto({
      identificacion: item.identificacion,
      fullName: item.nombre,
      address: item.domicilio,
      phone: item.telefono,
      email: item.correo
    });
    const formRefData = getValues();
    await triggerValidation();
    const isValid = Object.keys(errors).length < 1;
    handleFormRef(isValid ? formRefData : null);
  }

  return (
    <Card className={`my-3`} >
      <FalconCardHeader title="Referencia Personal">
      </FalconCardHeader>
      <CardBody className="bg-light border-top">
        <form onChange={onChange}>
          {(contactos?.length ? <Row>
            <Col >
              <FormGroup>
                <Label for="identificacion">
                  Referencia anterior
                </Label>
                <Select
                  placeholder=""
                  style="fullWidth-select"
                  onChange={onAnterior}
                  options={contactos}
                  getOptionLabel={option => `${option.identificacion} ${option.nombre}`}
                  getOptionValue={option => contactos.indexOf(option)}
                />
              </FormGroup>
            </Col>
          </Row> : <></>)}
          <Row>
            <Col lg={6} xs={12} >
              <FormGroup>
                <Label for="identificacion">
                  <RequiredMarked />
                  Identificación
                </Label>
                <Input
                  id="identificacion"
                  invalid={errors['identificacion']}
                  maxLength={20}
                  name="identificacion"
                  {...register("identificacion", {
                    required: true,
                    pattern: /^[0-9]{5,}$/
                  })}
                  value={contacto.identificacion}
                />
              </FormGroup>
            </Col>
            <Col lg={6} xs={12} >
              <FormGroup>
                <Label for="fullName">
                  <RequiredMarked />
                  Nombres y Apellidos
                </Label>
                <Input
                  className="text-uppercase"
                  id="fullName"
                  invalid={errors['fullName']}
                  maxLength={100}
                  name="fullName"
                  {...register("fullName", {
                    required: true,
                  })}
                  value={contacto.fullName}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col >
              <FormGroup>
                <Label for="address">
                  <RequiredMarked />
                  Domicilio
                </Label>
                <Input
                  className="text-uppercase"
                  id="address"
                  invalid={errors['address']}
                  maxLength={100}
                  name="address"
                  {...register("address", {
                    required: true,
                  })}
                  value={contacto.address}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12} >
              <FormGroup>
                <Label for="phone">
                  <RequiredMarked />
                  Teléfono
                </Label>
                <Input
                  id="phone"
                  invalid={errors['phone']}
                  name="phone"
                  maxLength={20}
                  {...register("phone", {
                    required: true,
                    pattern: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
                  })}
                  value={contacto.phone}
                />
              </FormGroup>
            </Col>
            <Col lg={6} xs={12} >
              <FormGroup>
                <WizardInput
                  type="email"
                  required
                  label="Correo"
                  invalid={errors['email']}
                  id="email"
                  maxLength={50}
                  name="email"
                  {...register("email", {
                    required: false,
                    validate: value => {
                      return value ? !!value.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/) : true;
                    }
                  })}
                  value={contacto.email}
                  errors={errors}
                />
              </FormGroup>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  )
}

export default PesonalReference